import styled from 'styled-components';
import { font, color, query, space } from '@design/templateFns';

export const Wrapper = styled.div`
  display: flex;
  gap: ${space('x8')};
  flex-direction: column-reverse;
  max-width: 1055px;
  @media screen and (${query.atLeast('tablet')}) {
    gap: ${space('x10')};
    flex-direction: row;
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (${query.atLeast('max')}) {
    gap: ${space('x14')};
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  @media screen and (${query.atLeast('tablet')}) {
    width: 514px;
  }
`;

export const ImageBox = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
  img {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: cover;
  }
`;
export const BioWrapper = styled.div`
  @media screen and (${query.atLeast('tablet')}) {
    width: 415px;
  }
`;

export const Name = styled.h1`
  ${font('headline-xl')};
  font-size: 35px;
  margin-top: 0;
  padding: 0;
  margin-bottom: 12px;
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 48px;
  }
`;

export const Title = styled.h2`
  ${font('subhead-sm')};
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 0;
  margin-bottom: 8px;
  > span {
    display: inline-block;
    margin: 0 5px;
    color: ${color('gray2')};
  }
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 16px;
  }
`;

export const SupplementalTitle = styled.h3`
  ${font('subhead-sm')};
  margin-bottom: 8px;
  padding: 0;
  font-size: 14px;
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 16px;
  }
`;

export const MainInfoWrapper = styled.div`
  margin-bottom: 2rem;
`;

export const InfoBlock = styled.div`
  ${font('body-md-light')};
  margin-bottom: 0.5rem;
  color: ${color('fg')};
  font-size: 14px;
  line-height: 18px;
  .info-block__pronouns {
    color: ${color('gray4')};
  }

  a {
    color: ${color('fg')};
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  a.office {
    text-decoration: none;
    border-bottom: 1px solid;
    line-height: 1.25;
  }
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const InfoBlockLicense = styled.span<{ $space?: boolean }>`
  ${font('body-md-light')};
  margin-bottom: ${({ $space }) => ($space ? '40px' : '8px')};
  color: ${color('fg')};
  font-size: 14px;
  line-height: 18px;
  .info-block__pronouns {
    color: ${color('gray4')};
  }

  a {
    color: ${color('fg')};
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  a.office {
    text-decoration: underline;
  }
  @media screen and (${query.atLeast('tablet')}) {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const InfoBlockContact = styled(InfoBlock)`
  color: ${color('gray4')};
  margin-bottom: 4px;
  font-weight: 700;
  a {
    color: ${color('gray4')};

    &:hover {
      color: ${color('gray5')};
    }
  }
`;

export const Label = styled.span`
  font-weight: 700;
  color: ${color('fg')};
`;

export const Eyebrow = styled.div`
  ${font('eyebrow-lg')};
  font-size: 12px;
  line-height: 18px;
  text-transform: uppercase;
  margin-top: 40px;
  margin-bottom: 15px;
  color: ${color('cta')};
  @media screen and (${query.atLeast('tablet')}) {
    margin-bottom: 20px;
    font-size: 14px;
  }
`;

export const AdvisorSocials = styled.div`
  margin-bottom: 4px;
  display: flex;
  gap: 16px;
`;

// For use in Story
export const StoryWrapper = styled.div`
  display: flex;
`;
